/* Kopfrausch Perueckenvergleich, Merkleiste im Galaxus-Stil.
   Runde 10, 20.08.2026. Ersetzt die App Spec Compare, die im Shop nichts anzeigt.
   Daten kommen aus templates/product.vergleich-json.liquid ueber ?view=vergleich-json

   Korrektur 20.08.2026, Runde 11:
   a) istPerueckenSeite prueft den Produkttyp jetzt exakt. Vorher genuegte ein
      Praefix, dadurch erschienen die Vergleichsknoepfe auch auf allen Produkten
      vom Typ "Peruecken Pflegeprodukte".
   b) Die Merkleiste erscheint nur noch auf Perueckenseiten, Peruecken-
      Kategorieseiten und der Vergleichsseite. Vorher stand sie auf jeder Seite
      des Shops, sobald etwas gemerkt war, auch auf 404 und bei den Pflegeprodukten. */
(function () {
  'use strict';

  var KEY = 'kr_vergleich';
  var MAX = 4;
  var VGL_SEITE = '/pages/peruecken-vergleich';
  var PERUECKEN_TYP = 'Perücken';
  var PERUECKEN_COLLECTIONS = ['perucken', 'echthaarperucken', 'kunsthaarperucken', 'hitzebestandiges-kunsthaar'];

  var ZEILEN = [
    ['preis', 'Preis ab'],
    ['haarqualitaet', 'Haarqualität'],
    ['farbe', 'Farbe'],
    ['laenge', 'Länge'],
    ['struktur', 'Haarstruktur'],
    ['groesse', 'Kopfumfang'],
    ['verstellbar', 'Weite verstellbar'],
    ['lace', 'Lace-Front'],
    ['silikon', 'Silikon-Antirutschstellen'],
    ['klebepads', 'Klebepads anbringbar'],
    ['innenleben', 'Innenleben'],
    ['scheitel', 'Scheitelposition']
  ];

  var cache = {};
  var merk = laden();

  function laden() {
    try {
      var r = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(r) ? r.slice(0, MAX) : [];
    } catch (e) { return []; }
  }

  function sichern() {
    try { window.localStorage.setItem(KEY, JSON.stringify(merk)); } catch (e) {}
  }

  /* Nur echte Perueckenseiten. Der Produkttyp muss exakt stimmen, sonst greift
     die Abfrage auch bei "Perücken Pflegeprodukte". */
  function istPerueckenSeite() {
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var t = (m && m.product && m.product.type) ? String(m.product.type).trim() : '';
    return t === PERUECKEN_TYP;
  }

  function istPerueckenKollektion() {
    var p = window.location.pathname;
    for (var i = 0; i < PERUECKEN_COLLECTIONS.length; i++) {
      if (p.indexOf('/collections/' + PERUECKEN_COLLECTIONS[i]) === 0) return true;
    }
    return false;
  }

  function istVergleichsSeite() {
    return window.location.pathname.indexOf(VGL_SEITE) === 0;
  }

  /* Die Merkleiste gehoert nur dorthin, wo es auch etwas zu vergleichen gibt. */
  function darfLeisteZeigen() {
    return istPerueckenSeite() || istPerueckenKollektion() || istVergleichsSeite();
  }

  function daten(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '?view=vergleich-json', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j) cache[handle] = j; return j; })
      .catch(function () { return null; });
  }

  function el(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }

  /* ---------- Knopfzustand ---------- */

  function knopfZeichnen(b) {
    var an = merk.indexOf(b.getAttribute('data-kr-handle')) > -1;
    b.classList.toggle('is-gemerkt', an);
    var t = b.querySelector('.kr-vgl__txt');
    var i = b.querySelector('.kr-vgl__ic');
    if (t) t.textContent = an ? 'Gemerkt' : 'Vergleichen';
    if (i) i.textContent = an ? '✓' : '＋';
    b.setAttribute('aria-pressed', an ? 'true' : 'false');
  }

  function alleKnoepfeZeichnen() {
    var bs = document.querySelectorAll('[data-kr-handle]');
    for (var i = 0; i < bs.length; i++) knopfZeichnen(bs[i]);
  }

  function umschalten(handle) {
    var p = merk.indexOf(handle);
    if (p > -1) {
      merk.splice(p, 1);
    } else {
      if (merk.length >= MAX) {
        hinweis('Sie können bis zu vier Modelle nebeneinander vergleichen. Entfernen Sie zuerst eines aus der Leiste.');
        return;
      }
      merk.push(handle);
      daten(handle);
    }
    sichern();
    alleKnoepfeZeichnen();
    leisteZeichnen();
  }

  function hinweis(text) {
    var h = document.getElementById('krVglHinweis');
    if (!h) {
      h = el('div', 'kr-vgl__hinweis');
      h.id = 'krVglHinweis';
      document.body.appendChild(h);
    }
    h.textContent = text;
    h.classList.add('is-an');
    window.setTimeout(function () { h.classList.remove('is-an'); }, 4000);
  }

  /* ---------- Knopf bauen ---------- */

  function knopf(handle, klein) {
    var b = el('button', 'kr-vgl__btn' + (klein ? ' kr-vgl__btn--klein' : ''));
    b.type = 'button';
    b.setAttribute('data-kr-handle', handle);
    b.appendChild(el('span', 'kr-vgl__ic', '＋'));
    b.appendChild(el('span', 'kr-vgl__txt', 'Vergleichen'));
    b.addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      umschalten(handle);
    });
    return b;
  }

  /* ---------- Produktseite ---------- */

  function produktseiteAufbauen() {
    if (!istPerueckenSeite()) return;
    if (document.querySelector('.kr-vgl__zeile')) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var handle = (window.location.pathname.split('/products/')[1] || '').split('?')[0].split('/')[0];
    if (!handle) return;

    var zeile = el('div', 'kr-vgl__zeile');
    zeile.appendChild(knopf(handle, false));
    var a = el('a', 'kr-vgl__btn kr-vgl__btn--link');
    a.href = VGL_SEITE;
    a.appendChild(el('span', 'kr-vgl__ic', '▦'));
    a.appendChild(el('span', null, 'Alle 27 Modelle'));
    zeile.appendChild(a);

    var ahv = document.querySelector('.kr-ahv');
    if (ahv && ahv.parentNode) {
      ahv.parentNode.insertBefore(zeile, ahv);
    } else {
      form.parentNode.insertBefore(zeile, form.nextSibling);
    }
    alleKnoepfeZeichnen();
  }

  /* ---------- Kategorieseite ---------- */

  function kartenAufbauen() {
    if (!istPerueckenKollektion()) return;
    var karten = document.querySelectorAll('.grid-product[data-product-handle]');
    for (var i = 0; i < karten.length; i++) {
      var k = karten[i];
      if (k.querySelector('[data-kr-handle]')) continue;
      var h = k.getAttribute('data-product-handle');
      if (!h) continue;
      var ziel = k.querySelector('.grid-product__meta') || k.querySelector('.grid-product__content');
      if (!ziel) continue;
      var wrap = el('div', 'kr-vgl__kartezeile');
      wrap.appendChild(knopf(h, true));
      if (ziel.parentNode && ziel.parentNode.tagName === 'A') {
        ziel.parentNode.parentNode.appendChild(wrap);
      } else {
        ziel.appendChild(wrap);
      }
    }
    alleKnoepfeZeichnen();
  }

  /* ---------- Merkleiste ---------- */

  function leiste() {
    var l = document.getElementById('krVglLeiste');
    if (l) return l;
    l = el('div', 'kr-vgl__leiste');
    l.id = 'krVglLeiste';
    l.innerHTML =
      '<div class="kr-vgl__leiste-innen">' +
        '<div class="kr-vgl__leiste-titel">Vergleichen</div>' +
        '<div class="kr-vgl__slots" id="krVglSlots"></div>' +
        '<div class="kr-vgl__leiste-aktion">' +
          '<button type="button" class="kr-vgl__leeren" id="krVglLeeren">Leeren</button>' +
          '<button type="button" class="kr-vgl__start" id="krVglStart">Vergleichen</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(l);
    document.getElementById('krVglLeeren').addEventListener('click', function () {
      merk = []; sichern(); alleKnoepfeZeichnen(); leisteZeichnen();
    });
    document.getElementById('krVglStart').addEventListener('click', oeffnen);
    return l;
  }

  function leisteZeichnen() {
    if (!darfLeisteZeigen()) return;
    var l = leiste();
    var slots = document.getElementById('krVglSlots');
    slots.innerHTML = '';
    for (var s = 0; s < MAX; s++) {
      if (s < merk.length) {
        (function (handle) {
          var d = el('div', 'kr-vgl__slot');
          var x = el('span', 'kr-vgl__slot-x', '×');
          x.title = 'Entfernen';
          x.addEventListener('click', function () { umschalten(handle); });
          d.appendChild(x);
          var n = el('span', 'kr-vgl__slot-name', handle);
          d.appendChild(n);
          slots.appendChild(d);
          daten(handle).then(function (j) {
            if (!j) return;
            var img = el('img');
            img.src = j.bild;
            img.alt = j.titel;
            d.insertBefore(img, d.firstChild);
            n.textContent = j.modell || j.titel;
          });
        })(merk[s]);
      } else {
        slots.appendChild(el('div', 'kr-vgl__slot kr-vgl__slot--leer', '＋'));
      }
    }
    var b = document.getElementById('krVglStart');
    b.disabled = merk.length < 2;
    b.textContent = merk.length < 2 ? 'Noch ein Modell wählen' : merk.length + ' Modelle vergleichen';
    l.classList.toggle('is-offen', merk.length > 0);
    document.body.classList.toggle('kr-vgl-leiste-an', merk.length > 0);
  }

  /* ---------- Vergleichsansicht ---------- */

  function wert(k, v) {
    if (v == null || v === '') return '<span class="kr-vgl__nein">keine Angabe</span>';
    if (v === 'Ja') return '<span class="kr-vgl__ja">Ja</span>';
    if (v === 'Nein') return '<span class="kr-vgl__nein">Nein</span>';
    return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;');
  }

  function oeffnen() {
    if (merk.length < 2) return;
    Promise.all(merk.map(daten)).then(function (ps) {
      ps = ps.filter(Boolean);
      if (ps.length < 2) { hinweis('Die Daten konnten nicht geladen werden. Bitte laden Sie die Seite neu.'); return; }
      var m = modal();
      var kopf = '<thead><tr><th></th>';
      ps.forEach(function (p) {
        kopf += '<th class="kr-vgl__th-p"><img src="' + p.bild + '" alt="' + p.titel + '">' +
                p.titel.replace(' - ', '<br>') + '</th>';
      });
      kopf += '</tr></thead><tbody>';
      var unterschiede = 0;
      ZEILEN.forEach(function (z) {
        var werte = ps.map(function (p) { return String(p[z[0]] == null ? '' : p[z[0]]); });
        var u = false;
        for (var i = 1; i < werte.length; i++) if (werte[i] !== werte[0]) u = true;
        if (u) unterschiede++;
        kopf += '<tr class="' + (u ? 'kr-vgl__u' : '') + '"><th>' + z[1] + '</th>';
        ps.forEach(function (p) { kopf += '<td>' + wert(z[0], p[z[0]]) + '</td>'; });
        kopf += '</tr>';
      });
      kopf += '<tr class="kr-vgl__zeile-link"><th></th>';
      ps.forEach(function (p) {
        kopf += '<td><a class="kr-vgl__btn kr-vgl__btn--klein" href="/products/' + p.handle + '">Zum Produkt</a></td>';
      });
      kopf += '</tr></tbody>';
      m.querySelector('#krVglTabelle').innerHTML = kopf;
      m.querySelector('#krVglUnter').textContent =
        ps.length + ' Modelle nebeneinander. ' + unterschiede + ' von ' + ZEILEN.length + ' Eigenschaften unterscheiden sich.';
      m.querySelector('#krVglNur').checked = false;
      m.querySelector('#krVglTabelle').classList.remove('kr-vgl__nur-u');
      m.classList.add('is-offen');
      document.documentElement.classList.add('kr-vgl-offen');
    });
  }

  function schliessen() {
    var m = document.getElementById('krVglModal');
    if (m) m.classList.remove('is-offen');
    document.documentElement.classList.remove('kr-vgl-offen');
  }

  function modal() {
    var m = document.getElementById('krVglModal');
    if (m) return m;
    m = el('div', 'kr-vgl__modal');
    m.id = 'krVglModal';
    m.innerHTML =
      '<div class="kr-vgl__box">' +
        '<div class="kr-vgl__druckkopf"><div class="kr-vgl__marke">Kopfrausch</div>' +
          '<div class="kr-vgl__druckzeile">Perücken im Vergleich, erstellt auf kopfrausch.ch. Von Betroffenen für Betroffene.</div></div>' +
        '<div class="kr-vgl__box-kopf">' +
          '<div><h2>Ihre Auswahl im Vergleich</h2><p id="krVglUnter"></p></div>' +
          '<div class="kr-vgl__box-aktion">' +
            '<label class="kr-vgl__schalter"><input type="checkbox" id="krVglNur"><span>Nur Unterschiede</span></label>' +
            '<button type="button" class="kr-vgl__zu" id="krVglZu" aria-label="Schliessen">×</button>' +
          '</div>' +
        '</div>' +
        '<div class="kr-vgl__rahmen"><table class="kr-vgl__tabelle" id="krVglTabelle"></table></div>' +
        '<div class="kr-vgl__legende">Hinterlegte Zeilen mit grünem Balken zeigen, worin sich die Modelle unterscheiden. Mit dem Schalter oben blenden Sie alles Gleiche aus.</div>' +
        '<div class="kr-vgl__fuss">' +
          '<button type="button" class="kr-vgl__btn kr-vgl__btn--sage" id="krVglDruck">⎙ Drucken oder als PDF sichern</button>' +
          '<button type="button" class="kr-vgl__btn" id="krVglMail">✉ Auswahl per Mail senden</button>' +
          '<a class="kr-vgl__btn kr-vgl__btn--leise" href="' + VGL_SEITE + '">Alle 27 Modelle</a>' +
          '<a class="kr-vgl__btn kr-vgl__btn--leise" href="/pages/ratgeber-kopfgroesse-messen">Kopfgrösse messen</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(m);
    m.addEventListener('click', function (e) { if (e.target === m) schliessen(); });
    m.querySelector('#krVglZu').addEventListener('click', schliessen);
    m.querySelector('#krVglNur').addEventListener('change', function () {
      m.querySelector('#krVglTabelle').classList.toggle('kr-vgl__nur-u', this.checked);
    });
    m.querySelector('#krVglDruck').addEventListener('click', function () { window.print(); });
    m.querySelector('#krVglMail').addEventListener('click', mailen);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') schliessen(); });
    return m;
  }

  function mailen() {
    Promise.all(merk.map(daten)).then(function (ps) {
      ps = ps.filter(Boolean);
      var NL = String.fromCharCode(10);
      var z = ['Diese Modelle habe ich mir bei Kopfrausch angeschaut:', ''];
      ps.forEach(function (p) {
        z.push(p.titel + ', ' + p.preis);
        z.push(p.haarqualitaet + ', ' + p.laenge + ', Kopfumfang ' + p.groesse);
        z.push(window.location.origin + '/products/' + p.handle);
        z.push('');
      });
      z.push('Alle 27 Modelle im Vergleich:');
      z.push(window.location.origin + VGL_SEITE);
      window.location.href = 'mailto:?subject=' +
        encodeURIComponent('Meine Perueckenauswahl bei Kopfrausch') +
        '&body=' + encodeURIComponent(z.join(NL));
    });
  }

  /* ---------- Start ---------- */

  function start() {
    produktseiteAufbauen();
    kartenAufbauen();
    if (merk.length && darfLeisteZeigen()) { leisteZeichnen(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Nachladen bei unendlichem Scrollen oder Filterwechsel
  var mo = new MutationObserver(function () {
    window.clearTimeout(mo._t);
    mo._t = window.setTimeout(kartenAufbauen, 250);
  });
  if (document.querySelector('.grid, #CollectionAjaxContent, main')) {
    mo.observe(document.querySelector('#CollectionAjaxContent') || document.querySelector('main') || document.body,
      { childList: true, subtree: true });
  }
})();
